import { useState, useEffect } from 'react';
import axios from 'axios';

const usePavanData = () => {
  const [pavanData, setPavanData] = useState(null);

  useEffect(() => {
    const cdnBase = process.env.REACT_APP_CDN_LINK || 'https://resources.swmc.com/';
    axios.get(`${cdnBase}mastermind/jsons/pavan.json?t=${Date.now()}`)
      .then(res => setPavanData(res.data))
      .catch(() => setPavanData(null));
  }, []);

  return pavanData;
};

export default usePavanData;
